import { KpiCard } from './KpiCard';
import {
  useCoverageRate,
  useIncidentRate,
  useLateCancellationRate,
  useNoShowPassengerRate,
  usePunctualityRate,
  useSecurityIncidentRate,
  useServiceRate,
} from '../../services/api/hooks/useDashboardRates';
import { useFilterStore } from '../filters/filterStore';

/**
 * « Taux d'acceptation » a été retiré le 11 septembre 2026 : il affichait la
 * même valeur que « Taux de couverture » (même route back), donc un doublon.
 */
export const KpiGrid = () => {
  const { scopes, dateRange } = useFilterStore();
  const input = { scopes, dateRange };

  const coverage = useCoverageRate(input);
  const punctuality = usePunctualityRate(input);
  const incident = useIncidentRate(input);
  const security = useSecurityIncidentRate(input);
  const service = useServiceRate(input);
  const lateCancellation = useLateCancellationRate(input);
  const noShow = useNoShowPassengerRate(input);

  return (
    <section aria-label="Indicateurs clés" className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard label="Taux de couverture" data={coverage.data} isLoading={coverage.isLoading} />
      <KpiCard label="Ponctualité" data={punctuality.data} isLoading={punctuality.isLoading} />
      <KpiCard label="Taux d'incident" data={incident.data} isLoading={incident.isLoading} />
      <KpiCard label="Incidents sécurité" data={security.data} isLoading={security.isLoading} />
      <KpiCard label="Taux de service" data={service.data} isLoading={service.isLoading} />
      <KpiCard label="Annulation tardive" data={lateCancellation.data} isLoading={lateCancellation.isLoading} />
      <KpiCard label="No-show passager" data={noShow.data} isLoading={noShow.isLoading} />
    </section>
  );
};
